import React, { useEffect, useState, useCallback } from 'react';
import { Card, Col, Form, Modal, Spinner, Button, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Fetcher } from '../../Helpers/fetcher';
import ReactPlayer from 'react-player';
import { Notify } from '../../Helpers/notification';
import TranscribeModal from '../VoiceCampaign/ListVoiceFiles/components/TranscribeModal';

const ListVoice = (props) => {
    const [voicelist, setVoicelist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [confimrTranscript, setConfimrTranscript] = useState(false);
    const [transcriptUrl, setTranscriptUrl] = useState("");

    const [confirmDelete, setConfirmDelete] = useState(false);
    const [confirmApprove, setConfirmApprove] = useState(false);
    const [confirmReject, setConfirmReject] = useState(false);
    const [showListenModal, setShowListenModal] = useState(false);

    const [selectedPromptId, setSelectedPromptId] = useState(0);
    const [selectedPromptUrl, setSelectedPromptUrl] = useState('');
    const [modalHeading, setModalHeading] = useState('');
    const [ttsFlag, setTtsFlag] = useState(false);

    const [remarks, setRemarks] = useState("");
    const [rejectRemarks, setRejectRemarks] = useState("");

    const paginationOption1 = {
        custom: true,
        totalSize: voicelist.length,
        sizePerPage: 5,
        sizePerPageList: [5],
    };

    const columns = [
        {
            dataField: 'promptId',
            text: 'Voice File Id',
            sort: true,
            hidden: false
        },
        {
            dataField: 'promptUrl',
            text: 'Prompt Url',
            sort: true,
            hidden: true
        },
        {
            dataField: 'name',
            text: 'File Name',
            sort: true,
            searchable: true
        },
        {
            dataField: 'promptCategory',
            text: 'File Type',
            sort: false,
            searchable: false
        },
        {
            dataField: 'promptStatus',
            text: 'Status',
            sort: false,
            searchable: false,
        },
        {
            dataField: 'username',
            text: 'Uploaded By',
            sort: true,
            searchable: true
        },
        {
            dataField: 'accountType',
            text: 'Account',
            sort: false,
            searchable: false
        },
        {
            dataField: 'uploadTime',
            text: 'Upload Time',
            sort: false,
            searchable: false
        },
        {
            dataField: 'approvalTime',
            text: 'Approval Time',
            sort: false,
            searchable: false
        },
        {
            dataField: 'delete_date',
            text: 'Deletion Date',
            sort: false,
            searchable: false
        },
        {
            dataField: 'deletedBy',
            text: 'Deleted By',
            sort: false,
            searchable: false
        },
        {
            dataField: 'remarks',
            text: 'Remarks',
            sort: false,
            searchable: false
        },
        {
            dataField: 'transcript',
            text: 'Transcript',
            sort: false,
            searchable: false
        },
        {
            dataField: 'action',
            text: 'Action',
            sort: false,
            searchable: false
        }
    ];

    const getPrompts = useCallback(async () => {
        setLoading(true);
        const apiPath = props.app.apiPath;
        const userId = props.app.userId;
        console.log({ apiPath, userId })
        try {
            const data = {
                "userId": userId,
                "remarks": "-1"
            }

            let response = await Fetcher.post(props.app.apiPath + '/api/obd/prompt/list/filter', {
                headers: { "Content-type": "application/json" },
                method: 'POST',
                body: JSON.stringify(data)
            });
            const pendingFiles = response.filter(prompt => prompt.promptStatus === 0);
            setVoicelist(pendingFiles);
        } catch (err) {
            console.error('Error in fetching Voice Files', err);
            Notify.notify('Error fetching voice files');
        } finally {
            setLoading(false);
        }
    }, [props.app.apiPath, props.app.userId]);

    useEffect(() => {
        getPrompts();
    }, [getPrompts, refreshKey]);

    const refreshList = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    const updateLocalState = (promptId, action) => {
        if (action === 'delete' || action === 'approve' || action === 'reject') {
            setVoicelist(prevList => prevList.filter(item => item.promptId !== promptId));
        }
    };

    const products = Array.isArray(voicelist) ? voicelist.map((prompt, index) => {
        var status = '';
        switch (prompt.promptStatus) {
            case 0:
                status = 'Pending';
                break;
            case 1:
                status = 'Approved';
                break;
            case 2:
                status = 'Rejected';
                break;
            case 9:
                status = 'Deleted';
                break;
            default:
                status = '';
                break;
        }
        var account = '';
        switch (prompt.accountType) {
            case 0:
                account = 'Promotional';
                break;
            case 1:
                account = 'Transactional';
                break;
            default:
                account = '';
                break;
        }
        let action = [];
        let transcript = [<button key={`${index}-approve-file`} className="btn-sm btn btn-default btn-primary" style={{ width: "max-content" }} onClick={(e) => handleConfirmTranscribe(prompt.promptUrl)} href="#">Transcribe Audio</button>];

        if (props.app.role === 'ROLE_SADMIN') {
            if ((prompt.promptStatus === 0) && (prompt.accountType === 1 || prompt.accountType === 0)) {
                action = [
                    <button key={`${index}-approve-file`} className="btn-sm btn btn-success ml-2" onClick={() => handleConfirmApprove(prompt.promptId)}>
                        Approve
                    </button>,
                    <button key={`${index}-reject-file`} className="btn-sm btn btn-danger ml-2" onClick={() => handleConfirmReject(prompt.promptId)}>
                        Reject
                    </button>
                ];

                if (prompt.promptCategory === 'tts') {
                    action.push(
                        <button key={`prompt1-listen-${index}`} className="btn-sm btn btn-primary ml-2" onClick={() => handleShowListenModalTTS(prompt.promptUrl, prompt.fileName)}>
                            Listen
                        </button>
                    );
                } else {
                    action.push(
                        <button key={`prompt1-listen-${index}`} className="btn-sm btn btn-primary ml-2" onClick={() => handleShowListenModal(prompt.promptUrl, prompt.fileName)}>
                            Listen
                        </button>
                    );
                }
            } else {
                if (prompt.promptCategory === 'tts') {
                    action = [
                        <button key={`prompt-${index}`} className="btn-sm btn btn-primary" onClick={() => handleShowListenModalTTS(prompt.promptUrl, prompt.fileName)}>
                            Listen
                        </button>
                    ];
                } else {
                    action = [
                        <button key={`prompt-${index}`} className="btn-sm btn btn-primary" onClick={() => handleShowListenModal(prompt.promptUrl, prompt.fileName)}>
                            Listen
                        </button>
                    ];
                }
            }

            if (prompt.promptStatus !== 9) {
                action.push(
                    <button key={`${index}-delete-file`} className="btn-sm btn btn-dark ml-2" onClick={() => handleConfirmDelete(prompt.promptId)}>
                        Delete
                    </button>
                );
            }
        }

        return {
            promptId: prompt.promptId,
            name: prompt.fileName,
            promptCategory: prompt.promptCategory,
            promptStatus: status,
            accountType: account,
            username: prompt.username,
            action: action,
            uploadTime: prompt.uploadTime,
            delete_date: prompt.delete_date,
            deletedBy: prompt.deletedBy,
            remarks: prompt.remarks,
            approvalTime: prompt.approvalTime,
            transcript
        };
    }) : [];

    const handleConfirmDelete = (promptId) => {
        setSelectedPromptId(promptId);
        setConfirmDelete(true);
    };

    const handleConfirmApprove = (promptId) => {
        setSelectedPromptId(promptId);
        setConfirmApprove(true);
    };

    const handleConfirmTranscribe = (url) => {
        setTranscriptUrl(url);
        setConfimrTranscript(true);
    };

    const handleConfirmReject = (promptId) => {
        setSelectedPromptId(promptId);
        setConfirmReject(true);
    };

    const handleShowListenModal = (promptUrl, fileName) => {
        setSelectedPromptUrl(promptUrl);
        setModalHeading('Listen Voice File');
        setTtsFlag(false);
        setShowListenModal(true);
    };

    const handleShowListenModalTTS = (promptUrl, fileName) => {
        setSelectedPromptUrl(promptUrl);
        setModalHeading('Listen Voice File (TTS)');
        setTtsFlag(true);
        setShowListenModal(true);
    };

    const handleCloseModals = () => {
        setConfirmDelete(false);
        setConfirmApprove(false);
        setConfirmReject(false);
        setShowListenModal(false);
        setRemarks("");
        setRejectRemarks("");
    };

    const handleDeletePrompt = async () => {
        try {
            const promptId = selectedPromptId;
            const userId = props.app.userId;
            const data = {};

            // Update local state immediately for better UX
            updateLocalState(promptId, 'delete');

            const response = await Fetcher.post(
                props.app.apiPath + '/api/obd/prompt/' + promptId + "/" + userId,
                {
                    headers: { "Content-type": "application/json" },
                    method: 'DELETE',
                    body: JSON.stringify(data)
                }
            );

            Notify.notify(response.message || 'Voice file deleted successfully');
            refreshList();
            handleCloseModals();
        } catch (err) {
            console.error('Error in Deleting Voice File', err);
            Notify.notify('Error deleting voice file');
            refreshList();
        }
    };

    const handleApprovePrompt = async (e) => {
        e.preventDefault();
        try {
            const promptId = selectedPromptId;
            const data = {
                promptId: promptId,
                remarks: remarks
            };

            updateLocalState(promptId, 'approve');

            const response = await Fetcher.post(
                props.app.apiPath + '/api/obd/prompt/approve',
                {
                    headers: { "Content-type": "application/json" },
                    method: 'POST',
                    body: JSON.stringify(data)
                }
            );

            Notify.notify(response.message || 'Voice file approved successfully');
            refreshList();
            handleCloseModals();
        } catch (err) {
            console.error('Error in Approval', err);
            Notify.notify('Error approving voice file');
            refreshList();
        }
    };

    const handleRejectPrompt = async (e) => {
        e.preventDefault();
        try {
            const promptId = selectedPromptId;
            const data = {
                promptId: promptId,
                remarks: rejectRemarks
            };

            updateLocalState(promptId, 'reject');

            const response = await Fetcher.post(
                props.app.apiPath + '/api/obd/prompt/reject',
                {
                    headers: { "Content-type": "application/json" },
                    method: 'POST',
                    body: JSON.stringify(data)
                }
            );

            Notify.notify(response.message || 'Voice file rejected successfully');
            refreshList();
            handleCloseModals();
        } catch (err) {
            console.error('Error in Rejecting', err);
            Notify.notify('Error rejecting voice file');
            refreshList();
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'remarks') {
            setRemarks(value);
        } else if (name === 'rejectRemarks') {
            setRejectRemarks(value);
        }
    };

    const { SearchBar, ClearSearchButton } = Search;
    const defaultSorted = [{
        dataField: 'promptId',
        order: 'desc'
    }];

    return (
        <Col sm={12}>
            <Card>
                <Card.Header>Pending Voice Files</Card.Header>
                <Card.Body>
                    <div className="user-list-table-cont">
                        {loading ? (
                            <div className="text-center">
                                <Spinner animation="border" />
                            </div>
                        ) : (
                            <PaginationProvider pagination={paginationFactory(paginationOption1)}>
                                {
                                    ({
                                        paginationProps,
                                        paginationTableProps
                                    }) => (
                                        <ToolkitProvider
                                            keyField="id"
                                            data={products}
                                            columns={columns}
                                            search
                                            bootstrap4
                                        >
                                            {
                                                props => (
                                                    <div className="">
                                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                        <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                        <hr />
                                                        <BootstrapTable
                                                            bordered={true}
                                                            defaultSorted={defaultSorted}
                                                            striped={true}
                                                            condensed
                                                            wrapperClasses="table-responsive"
                                                            classes="userCampaignList-table"
                                                            {...props.baseProps}
                                                            {...paginationTableProps}
                                                            noDataIndication={"No Pending Voice Files"}
                                                        />
                                                        <PaginationListStandalone {...paginationProps} />
                                                    </div>
                                                )
                                            }
                                        </ToolkitProvider>
                                    )
                                }
                            </PaginationProvider>
                        )}
                    </div>
                </Card.Body>

                {/* Delete Confirmation Modal */}
                <Modal size="md" show={confirmDelete} onHide={handleCloseModals}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Voice File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this file?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseModals} variant="secondary">CANCEL</Button>
                        <Button onClick={handleDeletePrompt} variant="primary">YES</Button>
                    </Modal.Footer>
                </Modal>

                {/* Approve Confirmation Modal */}
                <Modal size="md" show={confirmApprove} onHide={handleCloseModals}>
                    <Modal.Header closeButton>
                        <Modal.Title>Approve Voice File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to approve this file?
                        <Form className="add-campaign-form" onSubmit={handleApprovePrompt}>
                            <Row style={{ marginRight: '230px' }}>
                                <Col md={12}>
                                    <Form.Group className="form-group" controlId="remarks">
                                        <Form.Label>Remarks</Form.Label>
                                        <Form.Control
                                            required
                                            name="remarks"
                                            onChange={handleInputChange}
                                            value={remarks}
                                            type="text"
                                            placeholder="Remarks"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '200px' }}>
                                <Col sm={3}>
                                    <Button variant="primary" type="submit">YES</Button>
                                </Col>
                                <Col sm={3}>
                                    <Button onClick={handleCloseModals} variant="secondary">CANCEL</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Reject Confirmation Modal */}
                <Modal size="md" show={confirmReject} onHide={handleCloseModals}>
                    <Modal.Header closeButton>
                        <Modal.Title>Reject Voice File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to reject this file?
                        <Form className="add-campaign-form" onSubmit={handleRejectPrompt}>
                            <Row style={{ marginRight: '230px' }}>
                                <Col md={12}>
                                    <Form.Group className="form-group" controlId="rejectRemarks">
                                        <Form.Label>Remarks</Form.Label>
                                        <Form.Control
                                            required
                                            name="rejectRemarks"
                                            onChange={handleInputChange}
                                            value={rejectRemarks}
                                            type="text"
                                            placeholder="Remarks"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '200px' }}>
                                <Col sm={3}>
                                    <Button variant="primary" type="submit">YES</Button>
                                </Col>
                                <Col sm={3}>
                                    <Button onClick={handleCloseModals} variant="secondary">CANCEL</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Listen Modal */}
                <Modal size="lg" show={showListenModal} onHide={handleCloseModals}>
                    <Modal.Header closeButton>
                        <Modal.Title className="modal-heading">
                            {modalHeading}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {ttsFlag ? (
                            <ReactPlayer url={selectedPromptUrl} controls width='90%' height='80px' />
                        ) : (
                            <ReactPlayer url={selectedPromptUrl} controls width='90%' height='80px' />
                        )}
                    </Modal.Body>
                </Modal>

                <TranscribeModal show={confimrTranscript} onClose={() => setConfimrTranscript(false)} transcriptUrl={transcriptUrl} />

            </Card>
        </Col>
    );
};

export default ListVoice;